import { useState } from "react";

// redux
import { useStore } from "react-redux";
import { success } from "hyc-store/reducers/toast"

// helpers
import { editDate } from "../common/helper";

// components
import { Button } from "shared/components/bulma/button";
import { DatePicker } from "shared/components/bulma/date-picker";
import { Modal, ModalContent, ModalControl } from "shared/components/bulma/modal";

const ModalDate = ({ date, isActive, onConfirm, onDismiss }) => {
    const [newReturnDate, setNewReturnDate] = useState(date);

    const handleChange = (event) => {
        setNewReturnDate(+event.target.value);
    }
    const handleClick = () => { onConfirm(newReturnDate) }
    return (
        <Modal date={date} isActive={isActive} onConfirm={onConfirm} onDismiss={onDismiss} >
            <ModalContent>
                <DatePicker
                    className="is-250px"
                    id={'date-return'}
                    name="selectedDate"
                    value={newReturnDate}
                    onChange={handleChange}>
                </DatePicker>
            </ModalContent>
            <ModalControl>
                <Button className="is-info" name="close" onClick={onDismiss}>
                    Close
                </Button>
                <Button onClick={handleClick} className="is-primary">Save</Button>
            </ModalControl>
        </Modal>
    );
}

const EditReturnDate = ({ customer, box, onEdit }) => {
    const store = useStore();

    const [isActive, setActive] = useState(false);
    const [returnDate, setReturnDate] = useState(box.return_date);

    const handleClick = () => {
        setActive(true);
    }

    const dismiss = () => {
        setActive(false);
    }

    const edit = async (newDate) => {
        setActive(false);
        setReturnDate(newDate);

        await editDate({ customer: customer, box: box, newDate: newDate });
        if (onEdit) { onEdit(newDate); }
        store.dispatch(success('Success! Return date updated.'));
    }

    const Modal = () => {
        if (!isActive) {
            return null;
        }

        return (
            <ModalDate date={returnDate} isActive={isActive} onConfirm={edit} onDismiss={dismiss} />
        );
    }

    if (box.status === "partially_returned") {
        return null;
    }

    return (
        <>
            <Button className="is-small is-outlined is-link" onClick={handleClick} >
                <span className="icon">
                    <i className="fas fa-pen-square"></i>
                </span>
                <span>Edit Return Date</span>
            </Button>

            <Modal />
        </>
    );
}

export { EditReturnDate };
